// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2634":"2c796e83","2937":"eabe11fc","3133":"387b71f5"}[chunkId] || chunkId) + "." + {"217":"4d9577f0c6a3a58e","1167":"ec6975b3361e87c8","2634":"8e74a830d6389bd9","2937":"e4ecc13838fc5435","3133":"fe77b605ecf0a2fe","5194":"900644354105a4b9"}[chunkId] + ".js";
};